<template>
    <button class="hide-wrapper" @click.prevent="$emit('input', !value)">
        <i :class="value ? 'icon-chewron-down' : 'icon-chewron-down rotater'"></i>
        <slot></slot>
    </button>
</template>

<script type="text/babel">
export default {
    props: {
        value: {
            type: Boolean,
            required: true,
        },
    },
};
</script>
